import type { KioskPreviewMode } from '@biteinc/enums';

export function makeKioskPreviewUrl({
  previewMode,
  forcedMenuStructureId,
  orderId,
}: {
  previewMode: KioskPreviewMode;
  forcedMenuStructureId?: string;
  orderId?: string;
}): string {
  const embedId = app.location.get('embedId');

  const params = new URLSearchParams({
    previewMode,
    ...(forcedMenuStructureId ? { forcedMenuStructureId } : {}),
    ...(orderId ? { orderId } : {}),
  });
  return `/v2/kiosk-preview/${embedId}?${params.toString()}`;
}
